import React from "react";
import { IMPACT_PILLARS } from "../data/content";
import "../styles/impact.css";

function ImpactGrid() {
  return (
    <div className="impact-grid">
      {IMPACT_PILLARS.map((pillar) => (
        <div className="impact-card" key={pillar.title}>
          <h3 className="impact-card-title">{pillar.title}</h3>
          <p className="impact-card-detail">{pillar.detail}</p>
        </div>
      ))}
    </div>
  );
}

export default ImpactGrid;
